import React from 'react';
import { Card, Col, Collapse, Grid, Row, theme } from 'antd';

import SearchPerformanceInfoPanel from './SearchPerformanceInfoPanel';

type Props = React.PropsWithChildren<{
  title: string;
  panelTitle: string;
  panelItems: string[];
}>;

function GscDomainPickerCard({ title, panelTitle, panelItems, children }: Props) {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const isMobile = !screens.md;
  const isStacked = !screens.lg;
  const divider = `${token.lineWidth}px ${token.lineType} ${token.colorBorderSecondary}`;
  const infoPanel = <SearchPerformanceInfoPanel title={panelTitle} items={panelItems} fullWidth />;

  return (
    <Card title={title} styles={{ body: { paddingTop: token.padding, paddingBottom: token.padding } }}>
      <Row gutter={[token.marginXL, token.marginLG]}>
        <Col
          xs={24}
          lg={14}
          style={
            isStacked
              ? { borderBottom: divider, paddingBottom: token.paddingLG }
              : { borderRight: divider, paddingRight: token.paddingXL }
          }
        >
          {children}
        </Col>
        <Col xs={24} lg={10}>
          {isMobile ? (
            <Collapse size="small" items={[{ key: 'panel', label: panelTitle, children: infoPanel }]} />
          ) : (
            infoPanel
          )}
        </Col>
      </Row>
    </Card>
  );
}

export default GscDomainPickerCard;
